const en_transHistory = {

}

export default en_transHistory;